import _DatePicker from 'react-datepicker';
import React from 'react';
export default function DatePicker({ onChange, selected }) {
	const maxDate = new Date();
	maxDate.setDate(maxDate.getDate() + 10);
	return (
		<_DatePicker className={"search-form__datepicker"}
			onChange={onChange}
			selected={selected}
			dateFormat="dd.MM.yyyy"
			minDate={new Date()}
			maxDate={maxDate}
			locale="ru" />);
}